module.exports = __webpack_public_path__ + "img/XUMED.16364004.png";